




//import moment from 'moment';
import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
//import { FlatShading } from '../../public/assets/js/plugins/threejs';



export default (function () {
    return {


         //******************************************** Moment Info ********************************************
        //moment: function (date) {
        //    if (date === null) {
        //        return "فارغ";
        //    }
        //    // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        //    return moment(date).format('MMMM Do YYYY');
        //}

        DestroyElemntById(id) {
            const cancelButton = document.getElementById(id);
            if (cancelButton) {
                cancelButton.click(); // Trigger the click event
            }
        },


        




        //******************************************** User Info ********************************************

        CheckLoginStatus() {
            try {
                let loginDetails= JSON.parse(localStorage.getItem('currentUser-client'));
                if (this.loginDetails == null) {
                    window.location.href = '/login';
                }
                return loginDetails;
            } catch (error) {
                window.location.href = '/login';
            }
        },





        //******************************************** Card Step Info ********************************************
        nextStep(activeStep, formSteps) {
            if (activeStep < formSteps) {
                activeStep += 1;
                return activeStep;
            } else {
                activeStep -= 1;
                return activeStep;
            }

        },
        prevStep(activeStep) {
            if (activeStep > 0) {
                activeStep -= 1;
                return activeStep;
            }
        },









        //******************************************** Form Info ********************************************

        submitForm(formName) {
            let res;
            formName.validate((valid) => {
                if (valid) {
                    res = true;
                } else {
                    res = false;
                    this.showSwal('warning');
                }
            } );
            return res;
        },




        //******************************************** Message Info ********************************************
        showSwal(type) {
            if (type === "warning") {
                Swal.fire({
                    icon: 'warning',
                    title: 'عملية غير ناجحة',
                    html: 'الرجاء التحقق من ادخال جميع البيانات',
                    showCancelButton: false,
                }).then(() => {

                });
            }

        },

        ShowMessage(icon, title, html) {
            Swal.fire({
                icon: icon,
                title: title,
                html: html,
                showCancelButton: false,
            }).then(() => {

            });
        },

        // Several screens (Reports, Pricing, CancellationPolicy, Withdrawing,
        // TimeWindowsEditor) call `$helper.FailMessage(msg)` on error paths, but
        // only `ShowMessage` existed — so guarded call sites silently swallowed the
        // error and unguarded ones threw "FailMessage is not a function". Provide it
        // as a one-arg error toast so every error path surfaces a proper message.
        FailMessage(html) {
            this.ShowMessage('error', 'خطأ', html || 'حدث خطأ غير متوقع');
        },

        // Symmetric success toast for the same call sites that want one.
        SuccessMessage(html) {
            this.ShowMessage('success', 'تم', html || 'تمت العملية بنجاح');
        },

        // Every admin controller rejects via `StatusCode(BackMessages.StatusCode,
        // BackMessages.NotAuthorized)` — a 400 whose body is a BARE JSON STRING,
        // not an object. Call sites that read `e.response.data.Message` therefore
        // get `undefined` and fall through to their generic fallback, hiding the
        // real reason (session expired / not a super admin / validation text).
        // Extract the message whatever shape the server used, and distinguish a
        // transport failure (server down) from a server-sent rejection.
        ApiError(e, fallback) {
            if (e && !e.response) {
                // No response at all => request never completed.
                return 'تعذّر الاتصال بالخادم — تأكد من تشغيل الخدمة ثم أعد المحاولة';
            }
            const d = e && e.response ? e.response.data : null;
            if (typeof d === 'string' && d.trim()) return d;
            if (d && typeof d === 'object') {
                const msg = d.Message || d.message || d.Code || d.title || d.detail;
                if (msg) return msg;
            }
            return fallback || 'حدث خطأ غير متوقع';
        },






        //******************************************** Object Info ********************************************

        DynamicArabicEnterRequired(property) {
            return [
                { required: true, message: 'الرجاء التأكد من إدخال '+ property, trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /[\u0600-\u06FF]/, message: 'الرجاء إدخال حروف العربية فقط', trigger: 'blur' }
            ]
        },

        DynamicArabicSelectRequired(property) {
            return [
                { required: true, message: 'الرجاء التأكد من إختيار'+ property, trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /[\u0600-\u06FF]/, message: 'الرجاء إدخال حروف العربية فقط', trigger: 'blur' }
            ]
        },

        DynamicEnglishEnterRequired(property) {
            return [
                { required: true, message: 'الرجاء التأكد من إدخال ' + property, trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /^[a-zA-Z]+$/, message: 'الرجاء إدخال حروف إنجليزية فقط', trigger: 'blur' }
            ]
        },

        DynamicEnglishSelectRequired(property) {
            return [
                { required: true, message: 'الرجاء التأكد من إختيار'+ property, trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /^[a-zA-Z]+$/, message: 'الرجاء إدخال حروف إنجليزية فقط', trigger: 'blur' }
            ]
        },

        ArabicOnly() {
            return [
                { required: true, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /[\u0600-\u06FF]/, message: 'الرجاء إدخال حروف العربية فقط', trigger: 'blur' }
            ]
        },

        EnglishOnly() {
            return [
                { required: true, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /^[a-zA-Z]+$/, message: 'الرجاء إدخال حروف إنجليزية فقط', trigger: 'blur' }
            ]
        },

        EnglishOnlyNotRequired() {
            return [
                { required: false, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: false, pattern: /^[a-zA-Z]+$/, message: 'الرجاء إدخال حروف إنجليزية فقط', trigger: 'blur' }
            ]
        },

        DateOnly() {
            return [
                { required: false, message: 'الرجاء إدخال التاريخ', trigger: 'blur' },
                { required: false, pattern: /^(0?[1-9]|[12][0-9]|3[01])[\\/\\-](0?[1-9]|1[012])[\\/\\-]\d{4}$/, message: 'الرجاء إدخال التاريخ بصورة صحيحة', trigger: 'blur' }
            ]
        },

        Required() {
            return [
                { required: true, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
            ]
        },

        RequiredInput(input) {
            return [
                { required: true, message: "الرجاء إدخال بيانات " + " " + input, trigger: "blur" },
            ];
        },

        NumberOnlyRequired() {
            return [
                { required: true, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { required: true, pattern: /^[0-9]*$/, message: 'الرجاء إدخال ارقام فقط', trigger: 'blur' }
            ]
        },

        NumberOnlyNotRequired() {
            return [
                { required: false, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { required: false, pattern: /^[0-9]*$/, message: 'الرجاء إدخال ارقام فقط', trigger: 'blur' }
            ]
        },

        NumberOnly() {
            return [
                { required: true, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { min: 2, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /^[0-9]*$/, message: 'الرجاء إدخال ارقام فقط', trigger: 'blur' }
            ]
        },

        EmailOnly() {
            return [
                { required: true, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: true, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: 'الرجاء إدخال البريد الإلكتروني بطريقة صحيحة', trigger: 'blur' }
            ]
        },

        EmailNotRequierdOnly() {
            return [
                { required: false, message: 'الرجاء تعبئة البيانات', trigger: 'blur' },
                { min: 3, max: 150, message: 'يجب ان يكون الطول من 3 الي 150', trigger: 'blur' },
                { required: false, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, message: 'الرجاء إدخال البريد الإلكتروني بطريقة صحيحة', trigger: 'blur' }
            ]
        },


        NID() {
            return [
                { required: true, message: 'الرجاء ادخال  الرقم الوطني', trigger: 'blur' },
                { min: 12, max: 12, message: "يجب ان يكون طول الرقم الوطني 12 رقم ", trigger: "blur", },
                { required: true, pattern: /^[0-9]*$/, message: 'الرجاء إدخال ارقام فقط', trigger: 'blur' },
            ]
        },

        Phone() {
            return [
                {
                    required: true,
                    message: "الرجاء إدخال رقم الهاتف",
                    trigger: "blur",
                },
                {
                    min: 9,
                    max: 13,
                    message: "يجب ان يكون طول رقم الهاتف 9 ارقام علي الاقل",
                    trigger: "blur",
                },
                { required: true, pattern: /^[0-9]*$/, message: 'الرجاء إدخال ارقام فقط', trigger: 'blur' }
            ];
        },
      




        //********************************
        //Gender() {
        //    return [
        //        {
        //            id: 1,
        //            name: "ذكر"
        //        },
        //        {
        //            id: 2,
        //            name: 'أنثي'
        //        }
        //    ];
        //}





    };
})();